export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    background: p => p.tertiaryDark,
    backgroundColor: p => p.tertiaryDark,
    dotColor: p => p.tertiaryDark,
    primaryBlock: p => p.primaryLight
  },
  LIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => p.tertiaryLight,
    backgroundColor: p => p.tertiaryLight,
    dotColor: p => p.tertiarySemiLight,
    primaryBlock: p => p.primaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    dotColor: p => p.tertiarySemiLight,
    primaryBlock: p => p.primaryDark
  }
}
